// PDP Conversion Optimizations
document.addEventListener('DOMContentLoaded', () => {
  initPDPOptimizations();
});

function initPDPOptimizations() {
  // Add optimized product title for specific product
  optimizeProductTitle();

  // Add trust indicators
  addTrustIndicators();

  // Initialize sticky add to cart
  initStickyAddToCart();

  // Enhance product media
  enhanceProductMedia();

  // Add product badges
  addProductBadges();

  // Optimize description format
  optimizeProductDescription();
}

function optimizeProductTitle() {
  const productTitle = document.querySelector('.product__title .heading');
  const currentUrl = window.location.href;

  // Check if this is the pull-up bar product
  if (currentUrl.includes('widest-grip') || currentUrl.includes('pull-up-bar')) {
    if (productTitle && !productTitle.dataset.optimized) {
      productTitle.innerHTML = '<split-words class="split-words block" data-animate="fade-up">Widest Grip Doorframe Pull-Up Bar (Fits 26.7–32.6 in | Tool-Free Install)</split-words>';
      productTitle.dataset.optimized = 'true';
    }
  }
}

function addTrustIndicators() {
  const productForm = document.querySelector('.product-form');
  if (!productForm || productForm.querySelector('.product-trust-indicators')) return;

  const trustIndicators = document.createElement('div');
  trustIndicators.className = 'product-trust-indicators';
  trustIndicators.innerHTML = `
    <span>✓ Free Shipping</span>
    <span>✓ 30-Day Returns</span>
    <span>✓ Secure Checkout</span>
  `;

  const addToCartButton = productForm.querySelector('.btn');
  if (addToCartButton && addToCartButton.parentNode) {
    addToCartButton.parentNode.insertBefore(trustIndicators, addToCartButton.nextSibling);
  }
}

function initStickyAddToCart() {
  const productForm = document.querySelector('.product-form');
  if (!productForm) return;

  // Create sticky ATC
  const stickyATC = document.createElement('div');
  stickyATC.className = 'sticky-atc';

  const originalButton = productForm.querySelector('.btn');
  if (!originalButton) return;

  stickyATC.innerHTML = `
    <button type="button" class="btn btn--solid btn--full" onclick="scrollToAddToCart()">
      ${originalButton.textContent}
    </button>
  `;

  document.body.appendChild(stickyATC);
  document.body.classList.add('pdp-page');

  // Show/hide based on original form visibility
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyATC.classList.remove('visible');
        } else {
          stickyATC.classList.add('visible');
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '-50px 0px'
    }
  );

  observer.observe(productForm);

  // Add global function to scroll to original form
  window.scrollToAddToCart = function() {
    productForm.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    // Focus on the original button
    setTimeout(() => {
      originalButton.focus();
    }, 500);
  };
}

function enhanceProductMedia() {
  const mediaImages = document.querySelectorAll('.product__gallery img');

  mediaImages.forEach(img => {
    // Add zoom cursor on hover for desktop
    if (window.innerWidth >= 1024) {
      img.style.cursor = 'zoom-in';

      img.addEventListener('click', () => {
        openImageModal(img.src, img.alt);
      });
    }
  });
}

function openImageModal(src, alt) {
  const modal = document.createElement('div');
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    cursor: zoom-out;
  `;

  const img = document.createElement('img');
  img.src = src;
  img.alt = alt;
  img.style.cssText = `
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
  `;

  modal.appendChild(img);
  document.body.appendChild(modal);

  // Close on click or escape
  modal.addEventListener('click', () => {
    document.body.removeChild(modal);
  });

  document.addEventListener('keydown', function closeOnEscape(e) {
    if (e.key === 'Escape') {
      if (document.body.contains(modal)) {
        document.body.removeChild(modal);
      }
      document.removeEventListener('keydown', closeOnEscape);
    }
  });
}

function addProductBadges() {
  const productInfo = document.querySelector('.product__info');
  const currentUrl = window.location.href;

  if (productInfo && (currentUrl.includes('widest-grip') || currentUrl.includes('pull-up-bar'))) {
    const existingBadges = productInfo.querySelector('.product-badges');
    if (existingBadges) return;

    const badges = document.createElement('div');
    badges.className = 'product-badges';
    badges.style.cssText = 'margin: 16px 0;';

    badges.innerHTML = `
      <span class="product-badge product-badge--trust">260 lb Capacity</span>
      <span class="product-badge">Tool-Free Install</span>
      <span class="product-badge product-badge--trust">Korean No.1 Brand</span>
    `;

    // Insert after title
    const title = productInfo.querySelector('.product__title');
    if (title && title.nextSibling) {
      productInfo.insertBefore(badges, title.nextSibling);
    }
  }
}

function optimizeProductDescription() {
  const description = document.querySelector('.product__text.rte');
  if (!description) return;

  // Convert benefit lists to checkmark format
  const lists = description.querySelectorAll('ul');
  lists.forEach(list => {
    list.style.listStyle = 'none';
    list.style.padding = '0';

    const items = list.querySelectorAll('li');
    items.forEach(item => {
      item.style.cssText = `
        margin-bottom: 12px;
        display: flex;
        align-items: flex-start;
        gap: 12px;
      `;

      if (!item.querySelector('.check-icon')) {
        const checkIcon = document.createElement('span');
        checkIcon.className = 'check-icon';
        checkIcon.style.cssText = `
          color: #059669;
          font-weight: bold;
          flex-shrink: 0;
          margin-top: 2px;
        `;
        checkIcon.textContent = '✓';

        item.insertBefore(checkIcon, item.firstChild);
      }
    });
  });
}

// Enhanced Add to Cart with better feedback
function enhanceAddToCart() {
  const addToCartButtons = document.querySelectorAll('.product-form .btn');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', handleEnhancedAddToCart);
  });
}

async function handleEnhancedAddToCart(e) {
  const button = e.target;
  const form = button.closest('form');

  if (!form) return;

  e.preventDefault();

  // Show loading state
  form.classList.add('loading');
  button.disabled = true;

  try {
    const formData = new FormData(form);
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      // Success feedback
      const originalText = button.textContent;
      button.textContent = 'Added to Cart!';
      button.style.background = '#059669';

      // Open cart drawer if available
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.open) {
        cartDrawer.open();
      }

      setTimeout(() => {
        button.textContent = originalText;
        button.style.background = '';
      }, 2000);

    } else {
      throw new Error('Add to cart failed');
    }
  } catch (error) {
    console.error('Add to cart error:', error);
    button.textContent = 'Error - Try Again';
    button.style.background = '#dc2626';

    setTimeout(() => {
      button.textContent = 'Add to Cart';
      button.style.background = '';
    }, 3000);
  } finally {
    form.classList.remove('loading');
    button.disabled = false;
  }
}

// Initialize enhanced add to cart
document.addEventListener('DOMContentLoaded', () => {
  enhanceAddToCart();
});

// Utility function to add CSS if not already present
function addCSS(css) {
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
}

// Add mobile-specific styles
if (window.innerWidth < 1024) {
  addCSS(`
    .product__gallery img {
      border-radius: 16px;
    }

    .product-form {
      position: sticky;
      bottom: 20px;
      background: white;
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    }
  `);
}

// Performance optimization: lazy load non-critical features
setTimeout(() => {
  // Add micro-interactions
  addMicroInteractions();
}, 1000);

function addMicroInteractions() {
  // Hover effects for trust badges
  const trustBadges = document.querySelectorAll('.product-card__icon');
  trustBadges.forEach(badge => {
    badge.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px) scale(1.02)';
    });

    badge.addEventListener('mouseleave', function() {
      this.style.transform = '';
    });
  });
}

// Export for potential external use
window.PDPOptimizations = {
  initStickyAddToCart,
  enhanceProductMedia,
  optimizeProductDescription,
  addTrustIndicators
};